import { isChunkLoadError, reloadForChunkError } from "@/lib/runtime";

export const lazyWithRetry = <T>(importer: () => Promise<T>): Promise<T> => {
  return importer().catch((error) => {
    if (!isChunkLoadError(error)) throw error;

    if (reloadForChunkError()) {
      return new Promise<T>(() => {
        // Keep pending while reload happens
      });
    }

    throw error;
  });
};
